module.exports = __webpack_public_path__ + "static/img/price-1.66cc2857.png";